/* !
 * jQuery index v1.0.0
 * Copyright 2019, Connecty Inc.
 */
(function($, FUNCTIONS){
	const a = 'is-active';
	const v = 'is-visible';
	const breakpoint = 1024;
	const width = $(window).width();

	console.log(a);
	console.log(v);

	const mvSlider = () => {
		$('.mv-slider').slick({
			arrows: false,
			autoplay: true,
			adaptiveHeight: true,
			dots: true,
		    responsive: [
		    	{
					arrows: false,
		    		breakpoint: 768,
		    		settings: {
		    			slidesToShow: 1,
		    			centerMode: false,
		    		},
		    	},
		    ],
	   });
	   $('.idx-slider p').matchHeight();
	}

	const idxSlider = () => {
		$('.top-slider').slick({
			autoplay: true,
			adaptiveHeight: true,
			slidesToShow: 2,
			prevArrow: '<a class="slick-prev" href="#"><img src="/images/index/slide_arrow_l.webp" class="height-auto" alt="Previous slide" width="60" height="60"></a>',
			nextArrow: '<a class="slick-next" href="#"><img src="/images/index/slide_arrow_r.webp" class="height-auto" alt="Next slide" width="60" height="60"></a>',
		    responsive: [
		    	{
					arrows: false,
		    		breakpoint: 1024,
		    		settings: {
		    			slidesToShow: 1,
		    			centerMode: false,
		    		},
		    	},
		    ],
	   });
	   $('.idx-slider p').matchHeight();
	}

	const recruitSlider = () => {
		if(width <= 767){
		  } else {
			$('.recruit-slider').slick({
				arrows: false,
				autoplay: true,
				adaptiveHeight: true,
				centerMode: true,
				centerPadding: "15%",
				slidesToShow: 5,
			});
		  }
	}

	mvSlider();
	idxSlider();
	recruitSlider();



})(window.jQuery, window.FUNCTIONS);
